/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import { canonicalizeBars } from './priceUtils';

export const canonicalizeIndicatorData = (points) => {
    if (!Array.isArray(points)) return [];
    const byTime = new Map();
    points.forEach((point) => {
        if (!point || typeof point !== 'object') return;
        let time = Number(point.time);
        if (time > 1000000000000) time = Math.floor(time / 1000);
        if (!Number.isFinite(time)) return;
        const hasValue = Object.prototype.hasOwnProperty.call(point, 'value');
        const value = hasValue && point.value != null ? Number(point.value) : undefined;
        if (hasValue && point.value != null && !Number.isFinite(value)) return;
        const candidate = Number.isFinite(value) ? { ...point, time, value } : { time };
        const previous = byTime.get(time);
        if (!previous || Number.isFinite(candidate.value) || !Number.isFinite(previous.value)) {
            byTime.set(time, candidate);
        }
    });
    return [...byTime.values()].sort((a, b) => a.time - b.time);
};

export function getIndicatorKey(indicator, params, symbol, timeframe, paneType) {
  // Must match whatever structure your backend uses to rehydrate indicators on timeframe change!
  return [
    indicator,
    ...Object.entries(params).sort().map(([k, v]) => `${k}:${v}`),
    symbol,
    timeframe,
    paneType
  ].join('_');
}

export const padIndicatorData = (candles, indicatorData) => {
    const map = new Map((Array.isArray(indicatorData) ? indicatorData : []).map(d => [d.time, d.value]));
    const result = canonicalizeBars(candles).map(c => {
        // Always look up by the original (real) timestamp because indicator
        // data from the backend uses real timestamps.  Using the compressed
        // `c.time` would collide with pre-gap real timestamps after
        // compressGaps shifts post-gap bars backward.
        const lookupTime = c.time_real ?? c.time;
        const v = map.get(lookupTime);
        return Number.isFinite(v)
            ? { time: c.time, value: v }
            : { time: c.time };
    });
    return result;
};
